/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_In_Praesenz14Inputs */

const en__field_enum_tuda_in_praesenz14 = /** @type {(inputs: _Field_Enum_Tuda_In_Praesenz14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in person`)
};

const de__field_enum_tuda_in_praesenz14 = /** @type {(inputs: _Field_Enum_Tuda_In_Praesenz14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in Präsenz`)
};

/**
* | output |
* | --- |
* | "in person" |
*
* @param {_Field_Enum_Tuda_In_Praesenz14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_in_praesenz14 = /** @type {((inputs?: _Field_Enum_Tuda_In_Praesenz14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_In_Praesenz14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_in_praesenz14(inputs)
	return de__field_enum_tuda_in_praesenz14(inputs)
});
export { _field_enum_tuda_in_praesenz14 as "_field_enum_TUDA_IN_PRAESENZ" }